import memoize from 'lodash.memoize';
import { getConnectionDetails } from '@/services/network/connection';

// eslint-disable-next-line import/prefer-default-export
export const isSafeConnection = memoize(async () => {
  try {
    const connectionDetails = await getConnectionDetails();
    const isSafe = !connectionDetails.spam && !connectionDetails.tor;
    return isSafe;
  } catch {
    return false;
  }
});
